"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ENVIRONMENT", {
  enumerable: true,
  get: function get() {
    return _types.ENVIRONMENT;
  }
});
exports.default = void 0;

var _state = _interopRequireWildcard(require("./state"));

var _broadcast = _interopRequireDefault(require("./broadcast"));

var _processCache = _interopRequireDefault(require("./processCache"));

var _loadScript = _interopRequireDefault(require("./loadScript"));

var _getSafeOptions = _interopRequireDefault(require("./getSafeOptions"));

var _transformUserAgent = _interopRequireDefault(require("./transformUserAgent"));

var _processIntegrations = _interopRequireDefault(require("./processIntegrations"));

var _processGAClientId = _interopRequireDefault(require("./processGAClientId"));

var _urlHelpers = require("./urlHelpers");

var _heliotropeError = _interopRequireDefault(require("./heliotropeError"));

var _types = require("./types");

var _deepMergeWithArrayMerge = _interopRequireDefault(require("./deepMergeWithArrayMerge"));

var _bowser = _interopRequireDefault(require("bowser"));

var _dotComCookie = require("./dotComCookie");

var _auid = require("./auid");

var _deleteAmplitudeCookie = _interopRequireDefault(require("./deleteAmplitudeCookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// this resetState is used to "init" the state
(0, _state.resetState)();

var nonObjectError = () => (0, _heliotropeError.default)('An object must be passed in as the \'options\' argument');

var analytics = {
  init(options) {
    return _asyncToGenerator(function* () {
      if (_state.default.get().initialized) {
        throw (0, _heliotropeError.default)('Heliotrope already initialized');
      }

      if (typeof options !== 'object') {
        throw nonObjectError();
      }

      if (typeof options.segmentId !== 'string') {
        throw (0, _heliotropeError.default)('Did not pass in \'segmentId\' as a string');
      }

      if (typeof options.appId !== 'string') {
        throw (0, _heliotropeError.default)('Did not pass in \'appId\' as a string');
      } // Default to prod environment


      if (!options.environment) {
        options.environment = _types.ENVIRONMENT.PROD;
      } // processGAClientId and loadScript are both async, and both must resolve before continuing


      var processGaClientIdPromise = (0, _processGAClientId.default)();
      var loadScriptPromise = (0, _loadScript.default)(options);
      var auidPromise = (0, _auid.getAuid)({
        environment: options.environment,
        shouldRequestAuid: options.shouldRequestAuid,
        canSetAuidCookie: options.canSetAuidCookie
      });
      var [gaClientId, auid] = yield Promise.all([processGaClientIdPromise, auidPromise, loadScriptPromise]); // process the user agent

      var parsedUserAgent = _bowser.default.parse(window.navigator.userAgent);

      var userAgent = (0, _transformUserAgent.default)(parsedUserAgent); // filter out any un-permitted properties

      var safeOptions = (0, _getSafeOptions.default)(options); // create new object that combines userAgent, safe options, and sets initialized: true

      var safeOptionsWithUserAgent = (0, _deepMergeWithArrayMerge.default)(safeOptions, {
        persistedProperties: _objectSpread(_objectSpread({}, userAgent), {}, {
          userAgent: window.navigator.userAgent
        }, auid ? {
          auid
        } : {})
      }); // updateState must be called twice
      // gaClientId needs to be put into state first so processIntegrations can access it properly

      _state.default.update(_objectSpread(_objectSpread({}, safeOptionsWithUserAgent), {}, {
        gaClientId,
        initialized: true
      }));

      var {
        integrations,
        context
      } = (0, _processIntegrations.default)(safeOptionsWithUserAgent.integrations || {});

      _state.default.update({
        integrations,
        context
      }); // wait for this initial identify call to resolve before processing the cache


      yield analytics.identify({
        traits: (0, _deepMergeWithArrayMerge.default)(options.traits || {}, safeOptionsWithUserAgent.persistedProperties || {})
      });
      (0, _processCache.default)();
    })();
  },

  updateState(options) {
    var _arguments = arguments;
    return _asyncToGenerator(function* () {
      var {
        shouldIdentify = true
      } = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};

      if (typeof options !== 'object') {
        throw nonObjectError();
      }

      var safeOptions = (0, _getSafeOptions.default)(options);
      var processedIntegrations = (0, _processIntegrations.default)(safeOptions.integrations || {});

      _state.default.update(_objectSpread(_objectSpread({}, safeOptions), {}, {
        integrations: processedIntegrations
      }));

      if (_state.default.get().enabled && safeOptions.persistedProperties && shouldIdentify) {
        return analytics.identify({
          traits: (0, _deepMergeWithArrayMerge.default)({}, safeOptions.persistedProperties)
        });
      }

      return;
    })();
  },

  getState() {
    return _state.default.get();
  },

  getAuid: _auid.getAuid,

  track(options) {
    return _asyncToGenerator(function* () {
      if (typeof options !== 'object') {
        throw nonObjectError();
      }

      if (typeof options.eventName !== 'string') {
        throw (0, _heliotropeError.default)('Did not pass in \'eventName\' as a string');
      }

      var trackPropsSupplied = options.properties || {};

      var parsedCookies = _objectSpread({}, (0, _dotComCookie.get)());

      var filteredUrlParts = (0, _urlHelpers.getFilteredUrlPartsWithReferrer)(trackPropsSupplied);

      var trackProps = _objectSpread(_objectSpread(_objectSpread({}, trackPropsSupplied), parsedCookies), filteredUrlParts);

      var trackOptsBroadcast = (0, _deepMergeWithArrayMerge.default)(options, {
        properties: trackProps
      });
      return (0, _broadcast.default)(_objectSpread(_objectSpread({}, trackOptsBroadcast), {}, {
        segmentMethod: _types.SEGMENT_METHODS.TRACK
      }));
    })();
  },

  page(options) {
    return _asyncToGenerator(function* () {
      if (typeof options !== 'object') {
        throw nonObjectError();
      }

      if (typeof options.pageName !== 'string') {
        throw (0, _heliotropeError.default)("Did not pass in 'pageName' as a string. The type is ".concat(typeof options.pageName, " and the value is ").concat(options.pageName));
      }

      var pagePropsSupplied = options.properties || {};
      var filteredUrlParts = (0, _urlHelpers.getFilteredUrlPartsWithReferrer)(pagePropsSupplied);

      var pageProps = _objectSpread(_objectSpread({}, pagePropsSupplied), filteredUrlParts);

      var pageOptsBroadcast = (0, _deepMergeWithArrayMerge.default)(options, {
        properties: pageProps
      });
      return (0, _broadcast.default)(_objectSpread(_objectSpread({}, pageOptsBroadcast), {}, {
        segmentMethod: _types.SEGMENT_METHODS.PAGE
      }));
    })();
  },

  identify(options) {
    return _asyncToGenerator(function* () {
      if (typeof options !== 'object') {
        throw nonObjectError();
      }

      if (typeof options.traits !== 'object') {
        throw (0, _heliotropeError.default)('Did not pass in \'traits\' as an object');
      }

      return (0, _broadcast.default)(_objectSpread(_objectSpread({}, options), {}, {
        segmentMethod: _types.SEGMENT_METHODS.IDENTIFY
      }));
    })();
  },

  user() {
    var _window$analytics;

    return _state.default.get().initialized ? (_window$analytics = window.analytics) === null || _window$analytics === void 0 ? void 0 : _window$analytics.user() : undefined;
  },

  reset() {
    var _window$analytics2;

    (_window$analytics2 = window.analytics) === null || _window$analytics2 === void 0 ? void 0 : _window$analytics2.reset();
    (0, _auid.deleteAuidCookie)();
    (0, _deleteAmplitudeCookie.default)();
    (0, _state.resetState)();
  }

};
var _default = analytics;
exports.default = _default;
//# sourceMappingURL=main.js.map